import React from 'react';
import { Table } from 'react-bootstrap';
import BigHeader from '../../components/BigHeader';


const Parts = () => {

    return (
        <div>
        <BigHeader headerText={'Parts'} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/banner.png'}/>

      <p>
        Most of the sequences generated/used in our project are De Novo proteins not existing in nature, generated through RFDiffusion. We successfully cloned and began the screening of almost 60 of these sequences, but the characterization is not complete, so we did not annotate them as parts within the registry. However, if you are interested, you can find the full list of our screened protein sequences in the CSV file available below.
      </p>

      <p>
        <a href="https://static.igem.wiki/teams/4602/wiki/parisbettencourt2023-ggig-full-list.csv">
          https://static.igem.wiki/teams/4602/wiki/parisbettencourt2023-ggig-full-list.csv
        </a>
      </p>

      <p>For our characterized and annotated parts, refer to the table below:</p>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Reference</th>
            <th>Type</th>
            <th>Name</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602420">http://parts.igem.org/Part:BBa_K4602420</a>
            </td>
            <td>Plasmid</td>
            <td>pTElub01</td>
            <td>
              Plasmid vector for protein purification, specifically for generations of sfGFP fusion proteins (with part{' '}
              <a href="http://parts.igem.org/Part:BBa_K4602430">http://parts.igem.org/Part:BBa_K4602430</a>)
            </td>
          </tr>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602001">http://parts.igem.org/Part:BBa_K4602001</a>
            </td>
            <td>Coding</td>
            <td>HPV16_L1</td>
            <td>HPV16 major capsid protein (L1)</td>
          </tr>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602002">http://parts.igem.org/Part:BBa_K4602002</a>
            </td>
            <td>Coding</td>
            <td>StcE_X409</td>
            <td>C terminal domain (X409) of metalloprotease StcE</td>
          </tr>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602003">http://parts.igem.org/Part:BBa_K4602003</a>
            </td>
            <td>Coding</td>
            <td>hMUC2 CysD</td>
            <td>CysD region of human mucin MUC2</td>
          </tr>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602431">http://parts.igem.org/Part:BBa_K4602431</a>
            </td>
            <td>Coding</td>
            <td>62</td>
            <td>De novo designed T4 binder</td>
          </tr>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602004">http://parts.igem.org/Part:BBa_K4602004</a>
            </td>
            <td>Coding</td>
            <td>LEC_GREGR</td>
            <td>Galactose binding lectin from Crenomytilus grayanus</td>
          </tr>
          <tr>
            <td>
              <a href="http://parts.igem.org/Part:BBa_K4602430">http://parts.igem.org/Part:BBa_K4602430</a>
            </td>
            <td>Coding</td>
            <td>His_sfGFP_TEV</td>
            <td>
              Fusion protein domain containing Hisx6 purification tag, sfGFP, and TEV protease restriction site
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

export default Parts;